<script lang="ts">
	//UI
	//Utils
	//Types
	//Props
	export let fill = "#6D6F76";
	//Constants
	//Variables
	//Functions
	//Do
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 14 14"
	fill="none"
>
	<path
		d="M11.6597 3.01563C11.6597 3.20883 11.5001 3.37123 11.3041 3.37123H0.358328C0.162368 3.37123 0 3.21163 0 3.01563C0 2.81963 0.159568 2.65723 0.358328 2.65723H11.3069C11.5001 2.65723 11.6625 2.81683 11.6625 3.01563H11.6597Z"
		style={`fill:${fill}`}
	/>
	<path
		d="M13.9972 7.00003C13.9972 7.19603 13.8376 7.35563 13.6417 7.35563H0.358328C0.162368 7.35563 0 7.19883 0 7.00003C0 6.80123 0.159568 6.64443 0.358328 6.64443H13.6445C13.8376 6.64443 14 6.80123 14 7.00003H13.9972Z"
		style={`fill:${fill}`}
	/>
	<path
		d="M11.6597 10.9844C11.6597 11.1804 11.5001 11.3428 11.3041 11.3428H0.358328C0.162368 11.3428 0 11.1832 0 10.9844C0 10.7856 0.159568 10.6288 0.358328 10.6288H11.3069C11.5001 10.6288 11.6625 10.7884 11.6625 10.9844H11.6597Z"
		style={`fill:${fill}`}
	/>
</svg>

<style lang="scss">
</style>
